'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagVgAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx("path", { d: "M0 0H28V20H0V0Z", fill: "#07319C" }),
      /* @__PURE__ */ jsx("rect", { width: 12, height: 8, fill: "#001C5B" }),
      /* @__PURE__ */ jsx("path", { d: "M11.1 8L0 1.3V0H0.9L12 6.6V8H11.1Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M0.9 8L12 1.3V0H11.1L0 6.6V8H0.9Z", fill: "white" }),
      /* @__PURE__ */ jsx("path", { d: "M2.8 2.70003L0 1.00003V0.400024L3.8 2.70003H2.8Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M9.2 5.29997L12 6.99997V7.59998L8.2 5.29997H9.2Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M8.29999 2.7L12 0.4V0H11.6L7.29999 2.7H8.29999Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("path", { d: "M3.70001 5.3L0 7.6V8H0.4L4.70001 5.3H3.70001Z", fill: "#CA0028" }),
      /* @__PURE__ */ jsx("rect", { x: 4.69995, width: 2.6, height: 8, fill: "white" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 5.29999,
          width: 2.6,
          height: 12,
          transform: "rotate(-90 0 5.29999)",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("rect", { x: 5.19995, width: 1.6, height: 8, fill: "#CA0028" }),
      /* @__PURE__ */ jsx(
        "rect",
        {
          y: 4.79999,
          width: 1.6,
          height: 12,
          transform: "rotate(-90 0 4.79999)",
          fill: "#CA0028"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M17.3333 9.99998C17.3333 8.90628 17.3333 7.61313 17.3333 6.6658C17.3333 5.92942 17.9303 5.33331 18.6667 5.33331H22.6667C23.403 5.33331 24 5.92942 24 6.6658C24 7.61313 24 8.90628 24 9.99998C24 13.3333 20.6667 14.6667 20.6667 14.6667C20.6667 14.6667 17.3333 13.3333 17.3333 9.99998Z",
          fill: "#008339"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3333 8.00002C19.7015 8.00002 20 7.70155 20 7.33336C20 6.96517 19.7015 6.66669 19.3333 6.66669C18.9651 6.66669 18.6667 6.96517 18.6667 7.33336C18.6667 7.70155 18.9651 8.00002 19.3333 8.00002Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3333 9.3333C19.7015 9.3333 20 9.0349 20 8.6667C20 8.2985 19.7015 8 19.3333 8C18.9651 8 18.6667 8.2985 18.6667 8.6667C18.6667 9.0349 18.9651 9.3333 19.3333 9.3333Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3333 10.6667C18.9651 10.6667 18.6667 10.3682 18.6667 10C18.6667 9.63181 18.9651 9.33331 19.3333 9.33331C19.7015 9.33331 20 9.63181 20 10C20 10.3682 19.7015 10.6667 19.3333 10.6667Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M19.3333 10.6667C19.7015 10.6667 20 10.9651 20 11.3333C20 11.7015 19.7015 12 19.3333 12C18.9651 12 18.6667 11.7015 18.6667 11.3333C18.6667 10.9651 18.9651 10.6667 19.3333 10.6667Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.6667 11.3333C22.6667 11.7015 22.3682 12 22 12C21.6318 12 21.3333 11.7015 21.3333 11.3333C21.3333 10.9651 21.6318 10.6667 22 10.6667C22.3682 10.6667 22.6667 10.9651 22.6667 11.3333Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22 9.33331C22.3682 9.33331 22.6667 9.63181 22.6667 10C22.6667 10.3682 22.3682 10.6667 22 10.6667C21.6318 10.6667 21.3333 10.3682 21.3333 10C21.3333 9.63181 21.6318 9.33331 22 9.33331Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22 8C21.6318 8 21.3333 8.2985 21.3333 8.6667C21.3333 9.0349 21.6318 9.3333 22 9.3333C22.3682 9.3333 22.6667 9.0349 22.6667 8.6667C22.6667 8.2985 22.3682 8 22 8Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22 8.00002C21.6318 8.00002 21.3333 7.70155 21.3333 7.33336C21.3333 6.96517 21.6318 6.66669 22 6.66669C22.3682 6.66669 22.6667 6.96517 22.6667 7.33336C22.6667 7.70155 22.3682 8.00002 22 8.00002Z",
          fill: "#FFD033"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M20.6667 11.3333C21.0349 11.3333 21.3333 10.4379 21.3333 9.33328C21.3333 8.22878 21.0349 7.33331 20.6667 7.33331C20.2985 7.33331 20 8.22878 20 9.33328C20 10.4379 20.2985 11.3333 20.6667 11.3333Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M16.6667 13.3333C16.6667 14.6049 18.4879 15.3333 20.6667 15.3333C22.8455 15.3333 24.6667 14.6049 24.6667 13.3333C24.6667 12.9651 24.3682 12.6667 24 12.6667C23.6318 12.6667 23.3333 12.9651 23.3333 13.3333C23.3333 13.3461 23.1717 13.4989 22.7761 13.6572C22.239 13.872 21.4824 14 20.6667 14C19.8509 14 19.0943 13.872 18.5572 13.6572C18.1616 13.4989 18 13.3461 18 13.3333C18 12.9651 17.7015 12.6667 17.3333 12.6667C16.9651 12.6667 16.6667 12.9651 16.6667 13.3333Z",
          fill: "#FFD033"
        }
      )
    ]
  }
);
const VpFlagVgAsset = forwardRef(FlagVgAsset);

export { VpFlagVgAsset as default };
